import { render, staticRenderFns } from "./cta.vue?vue&type=template&id=2d960aa8&scoped=true&"
import script from "./cta.vue?vue&type=script&lang=js&"
export * from "./cta.vue?vue&type=script&lang=js&"
import style0 from "./cta.vue?vue&type=style&index=0&id=2d960aa8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d960aa8",
  null
  
)

/* custom blocks */
import block0 from "./cta.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports